import React from "react";
import * as actions from '../Actions';
// import ReactCrop from 'react-image-crop';
export default function UploadImgOverlay({ eleRef,tool }) {
    return (

        <div className="uploadImg-overlay" onClick={() => actions.clearMemoryImageData(eleRef,tool,false)}>
        <div className="uploadImg-popup" onClick={(e) => { e.stopPropagation(); return false; }}>
            <div className="uploadImg-header">
                <span className="B14_42">{tool=="MB" ? "UPLOAD MYBUMPIE" :"UPLOAD FACE A DAY IMAGE"}</span>
                <span className="closeButton icon" data-icon-font="C" onClick={() => actions.clearMemoryImageData(eleRef, tool, false)}></span>
            </div>
            <div className="uploadImg-container">
                <div className="cropContainer">
                    <div className="img_cntner before_crop">
                        <img src="" id="cropbox" className="" crossOrigin="anonymous" />
                    </div>

                    <div className="img_cntner after_crop" style={{ display: 'none' }}>
                        <img src="" id="aftercropimg" crossOrigin="anonymous" />
                        <img src="" id="mileFrame" crossOrigin="anonymous" style={{ display: 'none' }} />
                        {eleRef.state.selStickersAry && eleRef.state.selStickersAry.length > 0 && eleRef.state.selStickersAry.map((sticker, index) =>
                            <div key={sticker.eleKey} id={`sticker_${sticker.id}_${index}`} className="sticker_img">
                                <div className="sticker_img_inner">
                                    <div className="stick-close icon" data-icon-font="C"></div>
                                    <img className="stick-img" src={sticker.url.replace("http://", "https://")} crossOrigin="anonymous" id={`stickerimg_${sticker.id}_${index}`} data-id={sticker.id} data-index={index} />
                                    <div className="stick-rotate icon" id={`stickerrotate_${sticker.id}_${index}`}></div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>

                <input type="hidden" id="pChildId" name="pChildId" />
                <input type="hidden" id="x" name="x" />
                <input type="hidden" id="y" name="y" />
                <input type="hidden" id="w" name="w" />
                <input type="hidden" id="h" name="h" />
                <input id="rx" name="rx" type="hidden" value="" />
                <input id="ry" name="ry" type="hidden" value="" />
                <input id="rw" name="rw" type="hidden" value="" />
                <input id="rh" name="rh" type="hidden" value="" />
                <div className="setImgBtn" onClick={() => actions.checkCoords(eleRef,tool)}>
                    <span className="M14_white">SET IMAGE</span>
                </div>
                <div style={{ display: "none" }}>
                    <canvas id="preview" style={{ width: "1000px", height: "1000px", overflow: "hidden" }}></canvas>
                    <canvas id="finalcanvas" style={{ width: "1000px", height: "1000px", overflow: "hidden" }}></canvas>
                </div>
            </div>
        </div>
    </div>
    );
}
